import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { Location } from '@angular/common';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmCarrierComponent implements OnInit {

  public loading: boolean = false;
  private sub: any;
  public carrierUserID: string;
  public carrier;
  public factoringCompany;
  public sysconNumber: string = 'N/A';
  public raTypes = RequestAccessTypesEnum;
  public requestType: string;

  constructor(
    public carrierService: CarrierService,
    private flashMessageService: FlashMessageService,
    private route: ActivatedRoute,
    private _gaSvc: GoogleAnalyticsService,
    private router: Router,
    private customerService: CustomerService,
    private _redirectUrl: RedirctUrlService,
    private location: Location
  ) { }

  ngOnInit() {
    if (!this.carrierService.newCarrierUser.name) {
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
    this.sub = this.route.queryParams.subscribe(params => {
      this.carrierUserID = params['ID'];
      if (params['requestType']) {
        this.requestType = params['requestType']
      }
    });
    if (this.requestType === this.raTypes.FACTORING_COMPANY) {
      this.getFactoringCompany();
    } else {
      this.getCarrier();
    }
  }

  getCarrier() {
    this.carrierService.getCarrierDetail(this.carrierUserID).then(carrier => {
      this.carrier = carrier;
      this.carrier.xrefIds.forEach(xref => {
        if (xref.systemName === 'TPS') {
          this.sysconNumber = xref.id;
        }
      })
    }).catch(error => {
      this.flashMessageService.updateMessage(`Failed to get the carrier details for: ${this.carrierUserID}`, 5000, "danger");
    });
  }

  getFactoringCompany(){
    this.carrierService.getFactoringCompanyDetail(this.carrierUserID).then(factoringCompany => {
      this.factoringCompany = factoringCompany;
    }).catch(error => {
      this.flashMessageService.updateMessage(`Failed to get the factoring company details for: ${this.carrierUserID}`, 5000, "danger");
    });
  }

  public getVendorLocations() {
    return _.has(this.carrierService.newCarrierUser, "vendorLocations") ? _.get(this.carrierService.newCarrierUser, "vendorLocations") : [];
  }

  async confirm() {
    // ga(`send`, `event`, `User Admin`, `Save Add User Button`, `${this.carrierService.newCarrierUser.email}, ${this.carrierService.newCarrierUser.organizationName}`);
    this.loading = true;
    try {
      if (this.requestType !== this.raTypes.FACTORING_COMPANY && this.carrierService.shouldUpdateCarrierUnit()) {
        await this.customerService.updateCarriersModeAndUnit(this.carrierUserID, this.carrierService.carrierUnit.transportMode, this.carrierService.carrierUnit.businessUnit);
      }
      await this.carrierService.createCarrierUser();
      if (this.carrierService.newCarrierUser.user_from_request) {
        this._gaSvc.register(`User Admin`, `Save Add User Button`, `${this.carrierService.newCarrierUser.requestType}, ${this.carrierService.newCarrierUser.email}, ${this.carrierService.newCarrierUser.organizationName}`);
        await this.customerService.removeCarrierRequest(this.carrierService.newCarrierUser.requestId, this.carrierService.newCarrierUser.requestType);
      } else {
        this._gaSvc.register(`User Admin`, `Save Add User Button`, `${this.carrierService.newCarrierUser.email}, ${this.carrierService.newCarrierUser.organizationName}`);
      }
      this.carrierService.resetCarrierUser();
      this.flashMessageService.updateMessage("Successfully created user", 3000, "success");
    } catch (error) {
      this.flashMessageService.updateMessage(error, 5000, "danger");
    } finally {
      this.loading = false;
      this.router.navigate(['../../users'], { relativeTo: this.route });
    }
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }
}
